import MatchingAdvertisementWizardForm from './MatchingAdvertisementWizardForm.component';

export default MatchingAdvertisementWizardForm;